import React from 'react';
import PendingHoldsCard from './components/PendingHoldsIndex.jsx';

const PendingHoldsReport = () => <PendingHoldsCard />;

export default PendingHoldsReport;
